<script setup>
import AppLayout from '@/Layouts/AppLayout.vue'
import TutorTermsContent from '@/Components/Legal/TutorTermsContent.vue'
</script>

<template>
  <AppLayout>
    <div class="max-w-4xl mx-auto px-4 py-16">
      <h1 class="text-4xl font-bold text-gray-900 mb-8">Bindle Tutor Terms & Conditions</h1>
      <TutorTermsContent />
    </div>
  </AppLayout>
</template>
